var BootstrapMenu = require('bootstrap-menu');

export default {
    args: 'target',
    selector: null,
    menu: null,

    props: {
        target: String,
        selector: String,
    },

    data: {
    },

    connect() {
        this.menu = new BootstrapMenu(`#${this.el.getAttribute('id')} ${this.selector}`, {
            fetchElementData: function($rowElem) {
                var rowId = $rowElem.data('calculation');
                return { id: rowId, hasWriteAccess: $rowElem.is('.access-w') };
            },
            actions: [{
                name: 'Investitionsprognose kopieren',
                classNames: 'dropdown-item',
                iconClass: 'bi-clipboard2-fill',
                onClick: this.onCopyCalculation,
                isEnabled: function(row) {
                    return row.hasWriteAccess;
                }
            }, {
                name: 'Investitionsprognose verschieben',
                classNames: 'dropdown-item',
                iconClass: 'bi-box-arrow-up-right',
                onClick: this.onMoveCalculation,
                isEnabled: function(row) {
                    return row.hasWriteAccess;
                }
            }, {
                name: 'Auswertungen',
                classNames: 'dropdown-item',
                iconClass: 'bi-calculator',
                onClick: this.onKeyValuesSlidein,
            }, {
                name: 'Drucken',
                classNames: 'dropdown-item',
                iconClass: 'bi-printer',
                onClick: this.onPrintCalculation,
            }, {
                name: 'Löschen',
                classNames: 'dropdown-item text-danger',
                iconClass: 'bi-trash',
                onClick: this.onDeleteCalculation,
                isEnabled: function(row) {
                    return row.hasWriteAccess;
                }
            }],
        });
    },

    events: [{
        name: 'click',
        el(component) { return component.el.querySelectorAll('.btn-context-click'); },
        handler(ev) {
            ev.preventDefault();
            ev.stopPropagation();
            var rowEl = $(ev.target).closest(this.selector);
            this.menu.open(rowEl, ev);
        }
    }],

    methods: {
        onCopyCalculation(row) {
            if (row.id) {
                slidein.openUrl('/Project/CopyProjectCalculation/' + row.id);
            }
        },
        onMoveCalculation(row) {
            if (row.id) {
                slidein.openUrl('/Project/MoveProjectCalculation/' + row.id);
            }
        },
        onKeyValuesSlidein(row) {
            if (row.id) {
                slidein.openUrl('/Project/KeyCalculationsSlidein/' + row.id);
            }
        },
        onPrintCalculation(row) {
            if (row.id) {
                slidein.openUrl('/ProjectPrint/PrintDialog/' + row.id);
            }
        },
        onDeleteCalculation(row) {
            if (row.id) {
                messaging.askYesNo('Investitionsprognose löschen', 'Willst du diese Investitionsprognose wirklich in den Papierkorb verschieben?', function() {
                    var url = '/Calculation/DeleteCalculation/' + row.id;
                    connection.loadJson(url, null, function() {
                        connection.loadPart($('#project-parts'));
                        messaging.showGlobalMessage('success', null, 'Die Investitionsprognose wurde gelöscht.');
                    });
                });
            }
        },
    },

}
